import { nyxFeeds } from '../../../../datas/nyxFeed';
import { FeedPhotoItem } from './FeedPhotoItem';

interface FeedPhotosProps {
  indices?: number[]; // Array of indices to show from nyxFeed data
}

export const FeedPhotos = ({ indices = [0] }: FeedPhotosProps) => {
  const bgStyle =
    'bg-[linear-gradient(180deg,rgba(97,244,255,0.2)_0%,rgba(97,244,255,0)_100%)]';
  const bgStyles = [
    'bg-[linear-gradient(180deg,rgba(97,244,255,0.2)_0%,rgba(97,244,255,0)_100%)]',
    'bg-[linear-gradient(180deg,rgba(255,222,120,0.2)_0%,rgba(255,222,120,0)_100%)]',
    'bg-[linear-gradient(180deg,rgba(255,120,180,0.2)_0%,rgba(255,120,180,0)_100%)]',
    'bg-[linear-gradient(180deg,rgba(120,255,120,0.2)_0%,rgba(120,255,120,0)_100%)]',
  ];
  return (
    <div className="w-full">
      {indices.map((index, key: number) => {
        // Get data from nyxFeed using the index
        const photoData = nyxFeeds.imageSummaries[index];
        const imageUrl = nyxFeeds.imageUrls[index];
        const videoUrl = nyxFeeds.videoUrls[index];

        // Skip if index is out of bounds
        if (!photoData) {
          return null;
        }

        // Alternate between video and image based on the key
        const isVideo = key % 2 === 0; // Even indices = video, odd indices = image
        const mediaUrl = isVideo ? videoUrl : imageUrl;

        // Skip if media URL doesn't exist
        if (!mediaUrl) {
          return null;
        }

        return (
          <FeedPhotoItem
            bgStyle={bgStyles[key] || bgStyle}
            key={`feed-${index}-${key}`}
            photoData={photoData}
            imageUrl={isVideo ? undefined : imageUrl}
            videoUrl={isVideo ? videoUrl : undefined}
          />
        );
      })}
    </div>
  );
};
